import { ICreateObraAreaEmpreendimentoChecklistUseCase } from "../../../presentation/useCases/create/create_obra_area_empreendimento_checklist_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateObraAreaEmpreendimentoChecklistUseCase
 */

export class CreateObraAreaEmpreendimentoChecklistUseCase implements ICreateObraAreaEmpreendimentoChecklistUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createObraAreaEmpreendimentoChecklist(
    idObra: number,
    status: number,
    idIncorporacaoBloco: number,
    idIncorporacaoAndar: number | null,
    unidade: string,
    checklists: number[] | null,
  ): Promise<void> {
    await this.repository.createObraAreaEmpreendimentoChecklist(
      idObra,
      status,
      idIncorporacaoBloco,
      idIncorporacaoAndar,
      unidade,
      checklists,
    )
  }
}
